import React from 'react';
import NavbarBase from 'reactstrap/esm/Navbar';

// reactstrap 9 envuelve los hijos del Navbar en <div class="container-fluid">
// por defecto; reactstrap 8 no lo hacía y el tema (navbar vertical y superior)
// espera los hijos directos. Ver src/lib/reactstrap/index.js.
const Navbar = ({ container = false, ...props }) => <NavbarBase container={container} {...props} />;

export default Navbar;
